import { useAppSelector } from '../../store/hooks';

export default function Footer() {
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);
  const isConnected = useAppSelector((s) => s.auth.isConnected);
  const showDisconnected = isAuthenticated && !isConnected;

  return (
    <footer
      className={`hcf-footer__container hc-no-select${showDisconnected ? ' hcf-footer__container--disconnected' : ''}`}
    >
      {showDisconnected
        ? 'No internet connection'
        : `HalloChef v3.00 © 2016 – ${new Date().getFullYear()}`}
    </footer>
  );
}
